import React from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import imgMailSend from "~/assets/img/register-mail-send.png";

const MailSend = () => {
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<>
			<div className="phrase-wrap">
				<div className="img-wrap">
					<img
						src={imgMailSend}
						alt={t("pages.auth.FindPwPage.Find.MailSend.sendingMail")}
					/>
				</div>
				<h2 className="space-fix">{t("pages.auth.FindPwPage.Find.MailSend.sendedMail")}</h2>
			</div>
			<div className="btn-wrap">
				<button className="btn__solid" color="primary" onClick={() => navigate("/")}>
					{t("pages.auth.FindPwPage.Find.MailSend.check")}
				</button>
			</div>
		</>
	);
};

export default MailSend;
